const setBackToHomePage = () => {
  history.pushState({}, '', '');
  window.onpopstate = () => {
    window.location = window.siteObj.siteHomePage;
  };
};

export default setBackToHomePage;
